export default __webpack_public_path__ + "static/media/box-icon.352394a8.svg";